import { modifier } from 'ember-modifier';

interface ClickOutsideSignature {
  Element: Element;
  Args: {
    Positional: [onClickOutside: (event: MouseEvent) => void];
  };
}

export default modifier<ClickOutsideSignature>(function clickOutside(element, [onClickOutside]) {
  const handleClick = (event: MouseEvent) => {
    // Check if the click happened outside the element
    if (event.target && !element.contains(event.target as Node)) {
      onClickOutside(event);
    }
  };

  // Attach the click listener to the document
  document.addEventListener('click', handleClick);

  // Clean up the listener when the element is destroyed
  return () => {
    document.removeEventListener('click', handleClick);
  };
});
